<template>
  <v-layout row wrap class="list-section mx-3 mt-2 pa-3">
    <vue-headful v-bind:title="job.title" />
    <v-toolbar flat color="toolbarColor">
      <v-toolbar-title style="margin-left: -27px">Title: {{job.title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="back" color="btnColor" right flat>Back</v-btn>
      <v-btn icon :to="`/sonko/create/job?id=${job._id}`">
        <v-icon color="orange">edit</v-icon>
      </v-btn>
    </v-toolbar>

    <v-flex xs12 sm12>
      <p class="font-weight-bold">Description: <div v-html="job.description"></div></p>
    </v-flex>
    <v-flex xs12 sm12>
      <div><b>Expertise Category:</b> {{job.category}}</div>
    </v-flex>
    <v-flex xs12 sm12>
      <h4>Timeframe: <span class="font-weight-regular">{{job.timeFrame}}</span></h4>
    </v-flex>
    <v-flex xs12 sm12>
      <h4>Posted On: <span class="font-weight-regular">{{job.createdAt | moment("DD MMMM YYYY") }}</span></h4>
    </v-flex>
    <v-flex xs12 sm12>
      <hr>
      <label>Images</label>
    </v-flex>
    <v-flex xs12 sm4 v-for="(image, index) in job.images" v-bind:key="index" class="pa-2">
      <v-img v-if="image" :src="`${host}/uploads/jobs/${image}`" @click="openGallery(index)"></v-img>
    </v-flex>
    <LightBox
      v-if="job.images && job.images.length > 0"
      ref="lightbox"
      :media="media"
      :show-caption="false"
      :show-light-box="false"
    />
    <!-- image modal -->
    <v-dialog v-model="imageDialog" max-width="1200px">
      <v-card>
        <v-toolbar flat dense color="light-blue" dark>
          <v-toolbar-title class="title">Image preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon class="mb-2" @click.native="closeImage">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <img class="modal-img" :src="`${host}/uploads/jobs/${currentImage}`">
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of image modal -->
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import LightBox from 'vue-image-lightbox'
export default {
  name: "JobDetailsComponent",
  computed: {
    ...mapGetters(["host"])
  },
  components: {LightBox},
  data() {
    return {
      imageDialog: false,
      currentImage: null
    };
  },
  props: {
    job: {
      type: Object,
      default: function () { return {} }
    },
    media: {
      type: Array,
      default: []
    },
  },
  methods: {
    back() {
      this.$router.push("/vip_sonko/jobs/active");
    },
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    closeImage() {
      this.imageDialog = false;
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    }
  }
  /*mounted() {
    setInterval(() => document.title = this.job.title, 1000);
  },
  updated() {
    setInterval(() => document.title = this.job.title, 1000);
  }*/
};
</script>


<style scoped>
p {
  font-size: 16px;
}
</style>
